import React, { useEffect, useState } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import Image from "react-bootstrap/Image";
import PageTitle from "../../components/PageTitle";
import TablePagination from "../../components/TablePagination/TablePagination";
import CardWrapper from "../../layouts/CardWrapper";
import DataTable from "../../components/Table/Table";
import ImagePreviewLightbox from "../../components/ImagePreviewLightbox";
import { getHistory, listHistoryUser } from "../../services/historyServices";
import { useAlert } from "../../contexts/AlertContext";
import Dropdown from "react-bootstrap/Dropdown";
import { useAtomValue } from "jotai";
import { authAtom } from "../../states/auth";
import Form from "react-bootstrap/Form";
import { DayPicker } from "react-day-picker";
import { Link, useNavigate, useParams } from "react-router-dom";

const columns = [
  { label: "Date", key: "createdDate", sort: true },
  { label: "Session Type", key: "sessionType", sort: true },
  { label: "Company Name", key: "companyName", sort: true },
  { label: "Caller", key: "createdBy", sort: true },
  { label: "Receiver", key: "acceptedBy", sort: true },
  { label: "Expertise", key: "expertise.name", sort: true },
  { label: "Action", key: "expertise.name", sort: false },
];

const identifyUser = (data) => {
  let userMeta = { label: "", image: "", role: "" };
  if (data?.createdBy?.roleId == 3) {
    if (data?.createdBy?.createdBy === data.admin.id) {
      userMeta = {
        label: "Expert",
        role: "expert",
        image: "/images/user-circle-check-green.svg",
      };
    } else {
      userMeta = {
        label: "External Expert",
        role: "external_expert",
        image: "/images/user-circle-dashed-red.svg",
      };
    }
  } else if (data?.createdBy?.roleId == 5) {
    userMeta = {
      label: "Contact",
      role: "contact",
      image: "/images/user-circle-gear-blue.svg",
    };
  } else if (data?.createdBy?.roleId == 2) {
    if (data?.createdBy?.createdBy === data?.createdBy?.id) {
      userMeta = {
        label: "User",
        role: "internal_user",
        image: "/images/user-circle-gear-blue.svg",
      };
    } else {
      userMeta = {
        label: "User",
        role: "external_user",
        image: "/images/user-circle-yellow.svg",
      };
    }
  }
  return userMeta;
};

const formatDate = (date) => {
  if (!date) return "From - To Date";

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
  const year = date.getFullYear();

  return `${month}-${day}-${year}`;
};

 const sessionLabelMap = {
    all: "All Sessions",
    client: "Contacts",
    internal: "Team Members",
    experts: "External Experts",
  };

const getThisMonthRange = () => {
  const now = new Date();
  const start = new Date(now.getFullYear(), now.getMonth(), 1);
  const end = new Date(now.getFullYear(), now.getMonth() + 1, 0);
  return { from: start, to: end };
};

const DigitalReportCreate = () => {
  let { templateType } = useParams();
  const [historyList, setHistoryList] = useState(null);
  const [selectedItem, setSelectedItem] = useState(null);
  const [currentConversationId, setCurrentConversationId] = useState(null);
  const initialRange = getThisMonthRange();
  const [range, setRange] = useState(initialRange);
  const [showStatusTypeDropdown, setStatusTypeDropdown] = useState(false);
  const [hasMore, setHasMore] = useState(false);
  const [selectedPage, setSelectedPage] = useState(1);
  const [totalResults, setTotalResults] = useState(0);
  const { showAlert } = useAlert();
  const [showUsersDropdown, setShowUsersDropdown] = useState(false);
  const auth = useAtomValue(authAtom);
  const [tempUserIDs, setTempUserIDs] = useState([]);
  const [expertUsers, setExpertUsers] = useState([]);
  const [historyUserList, setHistoryUserList] = useState(null);
  const navigate = useNavigate();
  const [tempSessionType, setTempSessionType] = useState('all');
  const [userSearchFilter, setUserSearchFilter] = useState({
      search: ""
    });
  const [filter, setFilter] = useState({
    no_of_result: 10,
    page: 1,
    search: "",
    startDate: null,
    endDate: null,
    userIDs: [],
    sessionType: "all",
  });

  useEffect(() => {
    // if (range?.from || range?.to) {
    setHistoryList(null);
    setFilter((prev) => ({
      ...prev,
      startDate: formatDate(range?.from),
      endDate: formatDate(range?.to),
    }));

    // }
    console.log("filterAaA", filter);
  }, [range]);

  const changeFilterCriteriaByName = (name, value) => {
    console.log(name, value);
    filter[name] = value;
    setTempSessionType(value);
    setHistoryList(null);
    setFilter({ ...filter });
  };

  useEffect(() => {
      if (historyUserList?.length > 0) {
        setTempUserIDs(historyUserList.map(user => user.id));
      }
    }, [historyUserList]);

  useEffect(() => {
    changeFilterCriteriaByName("page", selectedPage);
  }, [selectedPage]);

  const getHistoryData = async () => {
    try {
      const { sessionType, ...rest } = filter;
      const data = await getHistory({ ...rest, filter: sessionType });
      setHistoryList(data?.data);
      setTotalResults(data?.totalResult);
    } catch (error) {
      console.error("Error fetching invitees:", error);
      showAlert({
        title: "Contact Access Notification",
        message: error?.response?.data?.message ?? "something went wrong",
        variant: "danger",
      });
    }
  };

  const selectedLabel = (() => {

    if (tempUserIDs.length === historyUserList?.length) {
      return "All Team Members";
    }
    if (tempUserIDs.length === 1) {
      const user = historyUserList.find(u => u.id === tempUserIDs[0]);
      return user ? `${user.firstName} ${user.lastName}` : "1 Selected";
    }

    if (tempUserIDs.length > 1) {
      return `${tempUserIDs.length} Selected`;
    }
    return "All Team Members";
  })();
  
  const getHistoryUsersData = async () => {
      try {
        const data = await listHistoryUser(userSearchFilter);
        setHistoryUserList(data?.data)
      } catch (error) {
        console.error("Error fetching invitees:", error);
        showAlert({
          title: "Contact Access Notification",
          message: error?.response?.data?.message ?? "something went wrong",
          variant: "danger",
        });
      }
    };

  useEffect(() => {
    // getHistoryUsersData();
    getHistoryData();
    getHistoryUsersData();
  }, []);

  useEffect(() => {
    // console.log("filter", filter);
    getHistoryData();
  }, [filter]);

  useEffect(() => {

    if (!['field', 'digital'].includes(templateType)) {
      navigate("/report-hub/create")
    }
  }, [templateType])
  const rowHandler = (item) => {
    if (currentConversationId !== item?.id) {
      setHasMore(true);
      setCurrentConversationId(item?.id);
    }

    setSelectedItem(item);
    // alert(item?.id)
    navigate("/report-hub/create/" + templateType + '/' + item?.id);
    // document.body.classList.add("sidebar-collapsed");
  };

  return (
    <>
      <Row className="align-items-end justify-content-between mb-4">
        <Col lg="7">
          <PageTitle title="Create Session Report" />
        </Col>
        <Col lg="5" className="text-end">
          <Button variant="white" className="btn-md border-0" onClick={() => { navigate(-1) }}>
            Cancel
          </Button>
        </Col>
      </Row>
      <CardWrapper>
        <Row className="align-items-center gy-4 gy-lg-0 mb-4">
          <Col lg="2">
            <div class="d-flex align-items-center gap-4">
              <h2 className="fs-5 fw-semibold text-gray-800 mb-0">
                Select Session
              </h2>
            </div>
          </Col>
          <Col className="flex-grow-1 text-end">
            <Row className="align-items-center justify-content-md-end gy-3 gy-lg-0 gx-2">
              <Col className="flex-grow-1">
                <Dropdown
                  show={showUsersDropdown}
                  onToggle={(isOpen) => setShowUsersDropdown(isOpen)}
                >
                  {[2,3].includes(auth.user.roleId) && (
                    <Dropdown.Toggle
                      variant="light"
                      className="filter-dropdown-button dropdown-toggle-arrow"
                      align="end"
                    >
                      All Users
                    </Dropdown.Toggle>
                  )}


                  <Dropdown.Menu
                    className="filter-dropdown-menu dropdown-menu-end p-0"
                    align="end"
                    popperConfig={{
                      modifiers: [
                        {
                          name: "offset",
                          options: { offset: [0, 5] },
                        },
                      ],
                    }}
                  >
                    <div className="filter-dropdown-menu-list p-2 border-bottom">
                      <input class="form-control form-control-search" aria-label="Search Input" placeholder="Search here..." autocomplete="off" type="text"></input>
                    </div>
                    <div className="px-3 pt-2 border-bottom">
                      <Form.Check
                        className="checkbox-primary mb-2"
                        type="checkbox"
                        label="Select All"
                        id="checkbox-all"
                        checked={
                          filter?.userIDs?.length == 0
                        }
                        onChange={(e) => {
                          const newUsers = e.target.checked
                            ? expertUsers.map((user) => user.id)
                            : [];
                          setHistoryList(null);
                          setFilter({ ...filter, userIDs: newUsers });
                        }}
                      />
                    </div>
                    <div className="filter-dropdown-menu-list px-3 py-2 border-bottom">
                      {historyUserList?.map((expert, index) => {
                        return (
                          <Form.Check
                            key={expert?.id}
                            className="checkbox-primary mb-2"
                            type="checkbox"
                            label={
                              expert.firstName + " " + expert.lastName
                            }
                            id={`user-${expert.id}`}
                            name="users"
                            checked={filter?.userIDs.includes(expert.id)}
                            onChange={(e) => {
                              const updatedUsers = e.target.checked
                                ? [...filter?.userIDs, expert.id]
                                : filter?.userIDs?.filter(
                                  (id) => id !== expert.id
                                );
                              setHistoryList(null);
                              setFilter({
                                ...filter,
                                userIDs: updatedUsers,
                              });
                            }}
                          />
                        );
                      })}
                    </div>
                    <div className="px-3 py-2 d-flex align-items-center justify-content-between">
                      <button
                        className="btn btn-sm btn-reset text-blue"
                        onClick={() => (
                          setShowUsersDropdown(false),
                          setHistoryList(null),
                          setFilter({ ...filter, userIDs: [] })
                        )}
                      >
                        Reset
                      </button>
                      <button
                        onClick={() => setShowUsersDropdown(false)}
                        className="btn btn-sm btn-blue"
                      >
                        Okay
                      </button>
                    </div>
                  </Dropdown.Menu>
                </Dropdown>
              </Col>
              <Col className="flex-grow-1">
                <Dropdown
                  show={showStatusTypeDropdown}
                  onToggle={(isOpen) => setStatusTypeDropdown(isOpen)}
                >
                  <Dropdown.Toggle
                    variant="light"
                    className="filter-dropdown-button form-control dropdown-toggle-arrow w-100 text-start"
                    align="end"
                  >
                    {sessionLabelMap[tempSessionType] || "All Sessions"}
                  </Dropdown.Toggle>

                  <Dropdown.Menu
                    className="filter-dropdown-menu dropdown-menu-end p-0"
                    align="end"
                    popperConfig={{
                      modifiers: [
                        {
                          name: "offset",
                          options: { offset: [0, 5] },
                        },
                      ],
                    }}
                  >
                    <div className="px-3 pt-2 border-bottom">
                      <Form.Check
                        className="radio-primary mb-3"
                        type="radio"
                        label="Select All"
                        value="all"
                        checked={filter.sessionType === "all"}
                        onChange={() => changeFilterCriteriaByName("sessionType", "all")}
                        id="radio-all"
                      />
                    </div>
                    <div className="px-4 pt-3 pb-2 border-bottom">
                      <Form.Check
                        className="radio-primary mb-3"
                        type="radio"
                        label="Contact"
                        value="client"
                        onChange={() => changeFilterCriteriaByName("sessionType", "client")}
                        checked={filter.sessionType === "client"}
                        id="radio-clients"
                      />

                      <Form.Check
                        className="radio-primary mb-3"
                        type="radio"
                        label="Team Members"
                        value="internal"
                        onChange={() => changeFilterCriteriaByName("sessionType", "internal")}
                        checked={filter.sessionType === "internal"}
                        id="radio-internal-users"
                      />
                      <Form.Check
                        className="radio-primary mb-3"
                        type="radio"
                        value="experts"
                        checked={filter.sessionType === "experts"}
                        onChange={() => changeFilterCriteriaByName("sessionType", "experts")}
                        label="External Experts"
                        id="radio-external-experts"
                      />
                    </div>
                    <div className="p-2 d-flex align-items-center justify-content-between">
                      <button
                        className="btn btn-xm btn-reset text-blue"
                        onClick={(e) => {
                          e.stopPropagation();            // prevent dropdown toggling due to click
                          changeFilterCriteriaByName("sessionType", "all");
                        }}
                      >
                        Reset
                      </button>
                      <button
                        className="btn btn-xm btn-blue"
                        onClick={(e) => {
                          e.stopPropagation();            // prevent dropdown toggling due to click
                          setStatusTypeDropdown(false);   // close the dropdown
                        }}
                      >
                        Okay
                      </button>
                    </div>
                  </Dropdown.Menu>
                </Dropdown>


              </Col>
              <Col className="flex-grow-1">
                <Dropdown align="end">
                  <Dropdown.Toggle
                    as="button"
                    id="to-date"
                    className="filter-dropdown-button form-control dropdown-toggle-calendar dropdown-toggle-none d-flex align-items-center justify-content-between gap-2 w-100"
                  >
                    {range?.from && range?.to
                      ? `${formatDate(range?.from)} - ${formatDate(
                        range?.to
                      )}`
                      : "From - To Date"}

                    <Image
                      src="/images/calendar-dots.svg"
                      alt="Calendar Check Icon"
                    />
                  </Dropdown.Toggle>
                  <Dropdown.Menu className="calendar-dropdown-menu dropdown-menu dropdown-menu-end">
                    <DayPicker
                      mode="range"
                      selected={range}
                      onSelect={(event) => (
                        console.log("datechange", event), setRange(event)
                      )}
                    // onDayClick={() => setShowCalendar(false)}
                    />
                  </Dropdown.Menu>
                </Dropdown>
              </Col>
              <Col lg="4">
                <input
                  type="text"
                  name="search"
                  onChange={(e) =>
                    changeFilterCriteriaByName("search", e.target.value)
                  }
                  className="form-control form-control-search"
                  aria-label="Search Input"
                  placeholder="Search here.."
                  autoComplete="off"
                />
              </Col>
            </Row>
          </Col>
        </Row>
        <DataTable>
          <thead>
            <tr>
              {columns.map((element) => {
                return (
                  <th class="cursor-pointer">
                    <div className="d-flex align-items-center gap-1">
                      {element?.label}{" "}
                      {element?.sort && (
                        <img
                          width="20"
                          height="20"
                          alt="Sort Icon"
                          class="ms-1"
                          src="/images/caret-up-down.svg"
                        />
                      )}
                    </div>
                  </th>
                );
              })}

              {/* <th class="cursor-pointer">
                  <div className="d-flex align-items-center gap-1">
                    Company Name{" "}
                    <img
                      width="20"
                      height="20"
                      alt="Sort Icon"
                      class="ms-1"
                      src="/images/caret-up-down.svg"
                    ></img>
                  </div>
                </th>
                <th class="cursor-pointer">
                  <div className="d-flex align-items-center gap-1">
                    Caller
                    <img
                      width="20"
                      height="20"
                      alt="Sort Icon"
                      class="ms-1"
                      src="/images/caret-up-down.svg"
                    ></img>
                  </div>
                </th>
                <th class="cursor-pointer">
                  <div className="d-flex align-items-center gap-1">
                    Expert
                    <img
                      width="20"
                      height="20"
                      alt="Sort Icon"
                      class="ms-1"
                      src="/images/caret-up-down.svg"
                    ></img>
                  </div>
                </th>
                <th class="cursor-pointer">
                  <div className="d-flex align-items-center gap-1">
                    Expertise
                    <img
                      width="20"
                      height="20"
                      alt="Sort Icon"
                      class="ms-1"
                      src="/images/caret-up-down.svg"
                    ></img>
                  </div>
                </th> */}
              {/* <th width="8%">Actions</th> */}
            </tr>
          </thead>
          <tbody>
            {historyList?.map((element) => {
              const userMeta = identifyUser(element);
              const anoterhMember = element.conversationMembers.find(
                (e) => e.user_id != element.createdBy.id
              );
              return (
                <tr>
                  <td className={selectedItem?.id === element?.id && 'bg-gray-50'} onClick={(e) => rowHandler(element)}>
                    {formatDate(
                      new Date(element?.endTime || element?.createdAt)
                    )}
                  </td>
                  <td className={selectedItem?.id === element?.id && 'bg-gray-50'} onClick={(e) => rowHandler(element)}>
                    <ul className="d-flex flex-wrap align-content-center gap-2 list-unstyled mb-0">
                      {element?.conversationType?.includes("chat") ? (
                        <li className="session-type-badge d-flex align-items-center gap-2">
                          <Image
                            src="/images/chats-circle.svg"
                            width={20}
                            height={20}
                            alt="Chat Circle Icon"
                          />{" "}
                          Chat
                        </li>
                      ) : (
                        <li className="session-type-badge d-flex align-items-center gap-2">
                          <Image
                            src="/images/video-camera-blue.svg"
                            width={20}
                            height={20}
                            alt="Video Camera Blue Icon"
                          />{" "}
                          Video
                        </li>
                      )}
                    </ul>
                  </td>
                  <td className={selectedItem?.id === element?.id && 'bg-gray-50'} onClick={(e) => rowHandler(element)}>
                    <div className="d-flex align-items-center gap-2">
                      <ImagePreviewLightbox
                        src={
                          userMeta?.image
                        }
                      >
                        <Image
                          width="32"
                          height="32"
                          alt="User Circle Gear Icon"
                          src={
                            userMeta?.image
                          }
                        />
                      </ImagePreviewLightbox>
                      {element?.createdBy?.companyName}
                    </div>
                  </td>
                  <td className={selectedItem?.id === element?.id && 'bg-gray-50'} onClick={(e) => rowHandler(element)}>
                    <div className="d-flex align-items-center gap-2">
                      {element.createdBy?.profilePic ? (
                        <ImagePreviewLightbox
                          className="user-avtar user-avtar-32"
                          src={
                            element?.createdBy?.profilePic
                          }
                        >
                          <Image
                            width="32"
                            height="32"
                            alt="User Avatar"
                            className="object-fit-cover rounded-circle"
                            onError={(e) => {
                              e.target.src = "/images/user-avatar-1.png";
                            }}
                            src={
                              element?.createdBy?.profilePic
                            }
                          />
                        </ImagePreviewLightbox>
                      ) : (
                        <Image
                          width={32}
                          height={32}
                          alt="User Avatar"
                          className="object-fit-cover rounded-circle"
                          src={`https://ui-avatars.com/api/?name=${element?.createdBy?.firstName}+${element?.createdBy?.lastName}&background=007bff&color=fff&size=100`}
                        />
                      )}
                      <span>
                        {element?.createdBy?.firstName}{" "}
                        {element?.createdBy?.lastName}
                      </span>
                    </div>
                  </td>
                  <td className={selectedItem?.id === element?.id && 'bg-gray-50'} onClick={(e) => rowHandler(element)}>
                    <div className="d-flex align-items-center gap-2">
                      {anoterhMember?.user?.profilePic ? (
                        <ImagePreviewLightbox
                          className="user-avtar user-avtar-32"
                          src={
                            anoterhMember?.user?.profilePic
                          }
                        >
                          <Image
                            width="32"
                            height="32"
                            alt="User Avatar"
                            className="object-fit-cover rounded-circle"
                            onError={(e) => {
                              e.target.src = "/images/user-avatar-1.png";
                            }}
                            src={
                              anoterhMember?.user?.profilePic
                            }
                          />
                        </ImagePreviewLightbox>
                      ) : (
                        <Image
                          width={32}
                          height={32}
                          alt="User Avatar"
                          className="object-fit-cover rounded-circle"
                          src={`https://ui-avatars.com/api/?name=${anoterhMember?.user?.firstName}+${anoterhMember?.user?.lastName}&background=007bff&color=fff&size=100`}
                        />)}
                      <span>
                        {anoterhMember?.user?.firstName}{" "}
                        {anoterhMember?.user?.lastName}
                      </span>
                    </div>
                  </td>
                  <td className={selectedItem?.id === element?.id && 'bg-gray-50'} onClick={(e) => rowHandler(element)}>
                    {element?.expertise?.name}
                  </td>
                  <td className={selectedItem?.id === element?.id ? 'bg-gray-50' : 'column-action-btn'}>
                    <button
                      type="button"
                      class="btn-reset btn btn-primary"
                      onClick={(e) => rowHandler(element)}
                    >
                      <Image
                        width="24"
                        height="24"
                        alt="Eye Icon"
                        src="/images/eye-primary.svg"
                      />
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </DataTable>
        <TablePagination
          selectedPage={selectedPage}
          setSelectedPage={setSelectedPage}
          totalResults={totalResults}
          resultsPerPage={10}
        />
      </CardWrapper>
    </>
  );
};

export default DigitalReportCreate;
